angular.module('wbDashboard')
.controller('MilestoneModBuildWealthController', ['$scope',
function ($scope) {
    //simple pages: ['name']

    angular.copy(['name',
        'portfolio-type', 'cash-amount', 'portfolios', 'portfolio-confirm',
        'allocation-start',
        // 'initial-deposit', 'auto-deposit'
    ], $scope.pages);

    //controller being initiated
    if ($scope.mod.action === "create" || !['simple', 'auto-deposit', 'portfolio-type', 'portfolio-simple-type', 'allocation-start', 'confirm'].includes($scope.$stateParams.page)) {
        $scope.goToPage($scope.pages[0]);
    }

    /**
     * Complete anything that needs to be done before current page is progressed past
     */
    $scope.mod.extra.postPageOps = function() {

    };
    $scope.mod.extra.getNextPage = function() {
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);
        var page = null;

        //noinspection FallThroughInSwitchStatementJS
        switch ($scope.$stateParams.page) {
            default:
                break;
        }
        return page;
    };

    /**
     * Pre-check for pages to either initialize them, or defer to a different page
     * Run recursively via the parent $scope.initNextPage method
     * @param page
     * @returns {*}
     */
    $scope.mod.extra.initNextPage = function(page) {
        var newPage = page;
        switch (page) {
            default:
                break;
        }
        return newPage;
    };

}]);
